export default "__VITE_ASSET__88be1c8e__"